import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { describe } from '@amzn/stencil-react-desc';
import { StencilConsumer } from "../context";
import { Col } from "../layout";
import { getThemeSpace, omit, withTestAttributes } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/core";

var FormWrapperBase = function FormWrapperBase(_ref) {
  var children = _ref.children,
      outerProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(StencilConsumer, null, function (context) {
    return ___EmotionJSX(Col, _extends({
      gridGap: getThemeSpace(context, 'S400')
    }, outerProps), children);
  });
};

var FormWrapperWithDocs = describe(FormWrapperBase).description('Sets vertical spacing between form elements.');
FormWrapperWithDocs.propTypes = _objectSpread({}, omit(Col.describedPropTypes, ['gridGap']));
var FormWrapper = withTestAttributes({
  component: 'StencilFormWrapper'
})(FormWrapperWithDocs);
FormWrapper.displayName = 'FormWrapper';
export default FormWrapper;